import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Creators as TaskCreators } from 'store/ducks/task';
import { Select, InputText } from 'triider-components';

import Modal from 'components/Modal';

import { ComentBox, Label, Coment } from './styles';

const CancelModal = ({
  cancelModalIsOpen, setCancelModalIsOpen, taskDetail, user, _cancelHiredTask, cancelTaskOptions, selectedTaskCanceled, _setCanceledTask, _getTaskDetail,
}) => {
  const [canceled, setCanceled] = useState(false);
  const [selectedTaskOption, setSelectedTaskOption] = useState('');
  const [cancelComent, setCancelComent] = useState('');

  useEffect(() => {
    if (selectedTaskCanceled) {
      setCanceled(true);
    }
  }, [selectedTaskCanceled]);

  const closeModal = () => {
    _setCanceledTask(false);
    setCancelModalIsOpen(false);
    _getTaskDetail(taskDetail.id);
  };

  return (
    <Modal
      isOpen={cancelModalIsOpen}
      toggle={() => closeModal()}
      title="Cancelar Pedido"
      disabled={!selectedTaskOption}
      footer={canceled ? 'Fechar' : 'Confirmar Cancelamento'}
      footerClick={() => (canceled ? closeModal() : _cancelHiredTask({
        task_problem: {
          feedback_id: parseInt(selectedTaskOption),
          comments: cancelComent,
          task_id: taskDetail.id,
          user_id: user.id,
        },
      }))}
    >
      {canceled ? (
        <p>Pedido cancelado com sucesso</p>
      ) : (
        <Fragment>
          <p>Ao cancelar o pedido você corre o risco de perder o valor oferecido pelos profissionais. Tem certeza que deseja cancelar?</p>
          <Select
            value={selectedTaskOption}
            size="smallBlock"
            arrowColor="greyDark"
            placeholder="Selecione o motivo"
            onChange={({ target }) => setSelectedTaskOption(target.value)}
            options={[{ value: '', label: '' }, ...cancelTaskOptions.map(option => (
              { value: option.id, label: option.text }
            ))]}
          />
          <Coment>
            <Label>Deseja deixar um comentário?</Label>
            <ComentBox hasValue={cancelComent} onChange={({ target }) => setCancelComent(target.value)} />
          </Coment>
        </Fragment>
      )}
    </Modal>
  );
};

const mapStateToProps = state => ({
  // taskDetail: state.task.taskDetail,
  selectedTaskCanceled: state.task.selectedTaskCanceled,
  taskQuoteProDetail: state.task.taskQuoteProDetail,
  cancelTaskOptions: state.task.cancelTaskOptions,
  user: state.auth.triiderUser.user,
});

const mapDispatchToProps = {
  _getTaskDetail: TaskCreators.getTaskDetailRequest,
  _cancelHiredTask: TaskCreators.cancelHiredTaskRequest,
  _setCanceledTask: TaskCreators.cancelHiredTaskSuccess,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CancelModal);
